import { render, staticRenderFns } from "./TraineeList.vue?vue&type=template&id=58c6596c&scoped=true"
import script from "./TraineeList.vue?vue&type=script&lang=js"
export * from "./TraineeList.vue?vue&type=script&lang=js"
import style0 from "./TraineeList.vue?vue&type=style&index=0&id=58c6596c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c6596c",
  null
  
)

export default component.exports